import { useEffect, useState } from "react";
import AssetManagementService from "services/assetManagement.service";
import ComboBoxRedux from "components/molecules/ComboBoxRedux";
import { useAppSelector } from "redux/hooks";

export default function SelectAssetCategory(props: any) {
  const assetCategories = useAppSelector((state) => state.assetManagement.assetCategories) || [];
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchCategories = async () => {
      setLoading(true);
      await AssetManagementService.getAssetCategories();
      setLoading(false);
    };
    fetchCategories();
  }, []);

  const options = assetCategories.map((cat: any) => ({
    label: cat.name,
    value: cat._id,
  }));

  // Support multiple selection by default (pass array)
  const comboBoxProps = {
    ...props.ComboBoxProps,
    multiple: props.ComboBoxProps?.multiple !== undefined ? props.ComboBoxProps.multiple : true,
  };

  return <ComboBoxRedux {...props} ComboBoxProps={comboBoxProps} options={options} loading={loading} />;
}

